const SSC_HEADER_CONTAINER_ID = "ssc-header-container";
const STICKY_SPACE_ID = "sticky-space";
const HEADER_ID = "header";
const OFFSET_PADDING = 16;

/**
 * Height of the sticky chrome above the scrollable content, measured fresh at call time rather than
 * cached, so newly-rendered banners and tab bars are accounted for. A hardcoded value under-scrolls
 * whenever the real stack is taller, which hides whatever sits directly above the scroll target.
 *
 * Desktop sums the header and the sticky tabs bar separately; mobile's `#header` already includes both.
 */
export const getStickyTopOffset = (isDesktop: boolean): number => {
  if (isDesktop) {
    const sscHeaderHeight = document.getElementById(SSC_HEADER_CONTAINER_ID)?.clientHeight ?? 0;
    const stickyTabsHeight = document.getElementById(STICKY_SPACE_ID)?.clientHeight ?? 0;

    return sscHeaderHeight + stickyTabsHeight + OFFSET_PADDING;
  }

  const headerHeight = document.getElementById(HEADER_ID)?.clientHeight ?? 0;

  return headerHeight + OFFSET_PADDING;
};
